<span>{{ navElement.label }}</span>